'use client';

import { CopyTradingPage } from '@flipster/features/src/copy-trading-page';

export default function Page() {
  return <CopyTradingPage />;
}
